import styled from 'styled-components';

const ServiceContentStyle = styled.section`
	--distanceEverBlock: var(--customDistance1);
	--sizeLineVertical: var(--sp22x);
	--distanceParagraph: var(--sp20x);
	--distanceBlockTitleContent: var(--sp3x);
	--categoryPad: var(--sp4x) var(--sp3x);
	--sizeBorder: 2px;
	--sizeLine: 2px;

	.inner-wrapper-service-content {
		display: flex;
		flex-direction: column;
		gap: var(--distanceEverBlock);
	}

	.ever-vertical-line {
		height: var(--sizeLineVertical);

		&.empty {
			&::before {
				display: none;
			}
		}

		&::before {
			content: '';
			position: relative;
			width: var(--sizeLine);
			height: 0;
			left: 50%;
			display: flex;
			background-color: var(--hoverPrimaryColor);
			transform: translateX(calc(var(--sizeLine) / 2 * -1));
		}
	}

	.line-horizontal {
		position: relative;
		width: calc((100% + var(--distanceParagraph)) - (100% + var(--distanceParagraph)) / var(--horizontalLineDelta) + var(--sizeLine));
		height: var(--sizeLine);
		display: flex;
		flex-direction: column-reverse;
		left: calc((100% - calc((100% + var(--distanceParagraph)) - (100% + var(--distanceParagraph)) / var(--horizontalLineDelta))) / 2 + var(--sizeLine) / -2);
		opacity: 0;
		background-color: var(--hoverPrimaryColor);
		transition: var(--trTime) ease-in 0.1s;
	}

	.wrapper-content {
		display: flex;
		justify-content: center;
		gap: var(--distanceParagraph);

		.every-content {
			flex: 1;
			display: grid;
			grid-template-rows: auto 1fr;
		}
	}

	.wrapper-link-item {
		display: flex;
		align-items: center;
		justify-content: center;

		.link-item {
			position: relative;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			gap: var(--sp0-5x);
			padding: var(--categoryPad);
			border: var(--sizeBorder) solid var(--hoverPrimaryColor);
			border-top-left-radius: var(--sp4x);
			border-top-right-radius: var(--sp4x);
			border-bottom: unset;
			opacity: 0;
			animation-delay: var(--delayMobile);
			transition: opacity var(--trTime) ease-in var(--trTime);

			.title {
				transition: color var(--trTime) ease-out;
			}

			svg {
				transition: fill var(--trTime) ease-out;
			}

			&::after {
				width: 0;
				height: var(--sizeBorder);
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				background-color: var(--hoverPrimaryColor);
				transition: var(--trTime) ease-out;
			}

			.icon-container {
				--iconSize: var(--p);

				width: 100%;
				display: flex;
				justify-content: flex-end;
			}
		}
	}

	.text-category-title {
		text-align: center;
		margin-bottom: var(--distanceBlockTitleContent);
		opacity: 0;
		transition: var(--trTime) ease-in;
	}

	.every-service-wrapper {
		&.active {
			.ever-vertical-line {
				&.inner-line {
					&::before {
						animation-delay: var(--trTime);
					}
				}

				&.even {
					&::before {
						animation: height200 calc(var(--trTime) * 2) ease-out forwards;
					}
				}

				&::before {
					animation: height100 var(--trTime) ease-out forwards;
				}
			}

			.link-item {
				opacity: 1;

				&::after {
					animation: running-border 0.7s ease-in-out forwards;
					animation-delay: calc(var(--trTime) * 2);
				}
			}

			.line-horizontal,
			.text-category-title {
				opacity: 1;
			}
		}
	}

	@keyframes height100 {
		from {
			height: 0;
		}
		to {
			height: var(--sizeLineVertical);
		}
	}

	@keyframes height200 {
		from {
			height: 0;
		}
		to {
			height: calc(var(--sizeLineVertical) * 2 + var(--sizeLine));
		}
	}

	@keyframes running-border {
		0% {
			width: 0;
			left: 0;
		}
		80% {
			width: 100%;
			left: 0;
		}
		100% {
			width: 100%;
			left: 0;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.wrapper-link-item {
				.link-item {
					&:hover {
						.title {
							color: var(--hoverPrimaryColor);
						}

						svg {
							fill: var(--hoverPrimaryColor);
						}
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeLineVertical: var(--sp22x);
		--distanceParagraph: var(--sp20x);
		--distanceBlockTitleContent: var(--sp3x);
		--categoryPad: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeLineVertical: var(--sp22x);
		--distanceParagraph: var(--sp20x);
		--distanceBlockTitleContent: var(--sp3x);
		--categoryPad: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeLineVertical: var(--sp18x);
		--distanceParagraph: var(--sp10x);
		--distanceBlockTitleContent: var(--sp3x);
		--categoryPad: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeLineVertical: var(--sp15x);
		--distanceParagraph: var(--sp10x);
		--distanceBlockTitleContent: var(--sp3x);
		--categoryPad: var(--sp3x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeLineVertical: var(--sp15x);
		--distanceParagraph: var(--sp4x);
		--distanceBlockTitleContent: var(--sp3x);
		--categoryPad: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceParagraph: 0px;
		--distanceBlockTitleContent: 0px;
		--sizeLineVertical: var(--sp12x);

		.line-horizontal {
			display: none;
		}

		.odd,
		.even {
			display: none;
		}

		.wrapper-content {
			display: flex;
			flex-direction: column;
		}

		.every-service-wrapper {
			&.active {
				.ever-vertical-line {
					&.empty {
						&::before {
							display: flex;
							animation: height100 var(--trTime) ease-out forwards;
							animation-delay: var(--delayMobile) !important;
						}
					}

					&.inner-line {
						&::before {
							animation-delay: var(--delayMobile) !important;
						}
					}

					&::before {
						animation: height100 var(--trTime) ease-out forwards;
						animation-delay: var(--delayMobile) !important;
					}
				}

				.link-item {
					width: 100%;
				}

				.title {
					opacity: 1;
				}
			}
		}
	}
`;

export default ServiceContentStyle;
